import { extendTheme } from "@chakra-ui/react";
import { globalStyles } from "../layout/styles/global";
import { buttonStyles } from "../layout/styles/comp/button";
import { linkStyles } from "../layout/styles/comp/link";
import { breakpoints } from "../layout/styles/comp/breakpoints";
import { badgeStyles } from "../layout/styles/comp/badge";
import { drawerStyles } from "../layout/styles/comp/drawer";
import { CardComponent } from "../layout/styles/card/Card";
import { CardBodyComponent } from "../layout/styles/card/CardBody";
import { CardHeaderComponent } from "../layout/styles/card/CardHeader";
import { MainPanelComponent } from "../layout/styles/layout/MainPanel";
import { PanelContentComponent } from "../layout/styles/layout/PanelContent";
import { PanelContainerComponent } from "../layout/styles/layout/PanelContainer";
import { inputStyles } from "../layout/styles/comp/input";
import colors from "./colors";

// import { mode } from "@chakra-ui/theme-tools";
const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};
const semanticTokens = {
  colors: {
    background: {
      default: "light.background",
      _dark: "dark.background",
    },

    surface: {
      default: "light.surface",
      _dark: "dark.surface",
    },
    card: {
      default: "light.card",
      _dark: "dark.card",
    },
    /* Button */
    button_teal_color: {
      default: "light.button_teal_color",
      _dark: "dark.button_teal_color",
    },
    button_teal_bg: {
      default: "light.button_teal_bg",
      _dark: "dark.button_teal_bg",
    },
    button_teal_hover: {
      default: "light.button_teal_hover",
      _dark: "dark.button_teal_hover",
    },
    button_gray_color: {
      default: "light.button_gray_color",
      _dark: "dark.button_gray_color",
    },
    button_gray_bg: {
      default: "light.button_gray_bg",
      _dark: "dark.button_gray_bg",
    },
    button_gray_hover: {
      default: "light.button_gray_hover",
      _dark: "dark.button_gray_hover",
    },
    button_csr_unselected_bg: {
      default: "light.button_csr_unselected_bg",
      _dark: "dark.button_csr_unselected_bg",
    },
    button_csr_border_color: {
      default: "light.button_csr_border_color",
      _dark: "dark.button_csr_border_color",
    },
    //navbar
    navbar_filter: {
      default: "light.navbar_filter",
      _dark: "dark.navbar_filter",
    },
    navbar_border_color: {
      default: "light.navbar_border_color",
      _dark: "dark.navbar_border_color",
    },
    navbar_main_text: {
      default: "light.navbar_main_text",
      _dark: "dark.navbar_main_text",
    },
    nabar_secondry_text: {
      default: "light.nabar_secondry_text",
      _dark: "dark.nabar_secondry_text",
    },
    navbar_bg: {
      default: "light.navbar_bg",
      _dark: "dark.navbar_bg",
    },
    navbar_shadow: {
      default: "light.navbar_shadow",
      _dark: "dark.navbar_shadow",
    },
    navbar_logout_button_bg: {
      default: "light.navbar_logout_button_bg",
      _dark: "dark.navbar_logout_button_bg",
    },
    navbar_logout_button_color: {
      default: "light.navbar_logout_button_color",
      _dark: "dark.navbar_logout_button_color",
    },
    navbar_logout_button_icon: {
      default: "light.navbar_logout_button_icon",
      _dark: "dark.navbar_logout_button_icon",
    },
    navbar_logout_button_shadow: {
      default: "light.navbar_logout_button_shadow",
      _dark: "dark.navbar_logout_button_shadow",
    },
    //info panel
    infopanel_avatar_bg: {
      default: "light.infopanel_avatar_bg",
      _dark: "dark.infopanel_avatar_bg",
    },
    infopanel_avatar_color: {
      default: "light.infopanel_avatar_color",
      _dark: "dark.infopanel_avatar_color",
    },
    infopanel_card: {
      default: "light.infopanel_card",
      _dark: "dark.infopanel_card",
    },
    infopanel_role_text: {
      default: "light.infopanel_role_text",
      _dark: "dark.infopanel_role_text",
    },
    infopanel_data_text: {
      default: "light.infopanel_data_text",
      _dark: "dark.infopanel_data_text",
    },
    infopanel_theme_bg: {
      default: "light.infopanel_theme_bg",
      _dark: "dark.infopanel_theme_bg",
    },
    //sidebar
    sidebar: {
      default: "light.sidebar",
      _dark: "dark.sidebar",
    },
    sidebar_select_div: {
      default: "light.sidebar_select_div",
      _dark: "dark.sidebar_select_div",
    },
    sidebar_select_icon_bg: {
      default: "light.sidebar_select_icon_bg",
      _dark: "dark.sidebar_select_icon_bg",
    },
    sidebar_unselect_icon_bg: {
      default: "light.sidebar_unselect_icon_bg",
      _dark: "dark.sidebar_unselect_icon_bg",
    },
    sidebar_select_icon_color: {
      default: "light.sidebar_select_icon_color",
      _dark: "dark.sidebar_select_icon_color",
    },
    sidebar_unselect_icon_color: {
      default: "light.sidebar_unselect_icon_color",
      _dark: "dark.sidebar_unselect_icon_color",
    },
    sidebar_select_text: {
      default: "light.sidebar_select_text",
      _dark: "dark.sidebar_select_text",
    },
    sidebar_unselect_text: {
      default: "light.sidebar_unselect_text",
      _dark: "dark.sidebar_unselect_text",
    },
    sidebar_hover: {
      default: "light.sidebar_hover",
      _dark: "dark.sidebar_hover",
    },
    //Box Panel
    boxpanel_style_color: {
      default: "light.boxpanel_style_color",
      _dark: "dark.boxpanel_style_color",
    },
    boxpanel_style_shadow: {
      default: "light.boxpanel_style_shadow",
      _dark: "dark.boxpanel_style_shadow",
    },
    //Input
    input_label_bg: {
      default: "light.input_label_bg",
      _dark: "dark.input_label_bg",
    },
    input_label_color: {
      default: "light.input_label_color",
      _dark: "dark.input_label_color",
    },
    input_border_color:{
      default:"light.input_border_color",
      _dark:"dark.input_border_color"
    },
    input_searchbar_bg: {
      default: "light.input_searchbar_bg",
      _dark: "dark.input_searchbar_bg",
    },
    input_disabled_bg: {
      default: "light.input_disabled_bg",
      _dark: "dark.input_disabled_bg",
    },
    input_disabled_text: {
      default: "light.input_disabled_text",
      _dark: "dark.input_disabled_text",
    },
    input_disabled_label: {
      default: "light.input_disabled_label",
      _dark: "dark.input_disabled_label",
    },
    input_readonly_bg: {
      default: "light.input_readonly_bg",
      _dark: "dark.input_readonly_bg",
    },
    input_readonly_text: {
      default: "light.input_readonly_text",
      _dark: "dark.input_readonly_text",
    },
    input_readonly_label: {
      default: "light.input_readonly_label",
      _dark: "dark.input_readonly_label",
    },
    input_readonly_border: {
      default: "light.input_readonly_border",
      _dark: "dark.input_readonly_border",
    },
    input_search_bg: {
      default: "light.input_search_bg",
      _dark: "dark.input_search_bg",
    },
    input_search_text: {
      default: "light.input_search_text",
      _dark: "dark.input_search_text",
    },
    input_search_placeholder: {
      default: "light.input_search_placeholder",
      _dark: "dark.input_search_placeholder",
    },
    input_search_border: {
      default: "light.input_search_border",
      _dark: "dark.input_search_border",
    },
    input_search_icon: {
      default: "light.input_search_icon",
      _dark: "dark.input_search_icon",
    },
    input_search_button_bg: {
      default: "light.input_search_button_bg",
      _dark: "dark.input_search_button_bg",
    },
    input_search_button_border: {
      default: "light.input_search_button_border",
      _dark: "dark.input_search_button_border",
    },
    input_search_button_icon: {
      default: "light.input_search_button_icon",
      _dark: "dark.input_search_button_icon",
    },

    input_search_button_hover_bg: {
      default: "light.input_search_button_hover_bg",
      _dark: "dark.input_search_button_hover_bg",
    },
    input_search_button_hover_border: {
      default: "light.input_search_button_hover_border",
      _dark: "dark.input_search_button_hover_border",
    },
    input_search_button_hover_icon: {
      default: "light.input_search_button_hover_icon",
      _dark: "dark.input_search_button_hover_icon",
    },

    input_search_button_disabled_bg: {
      default: "light.input_search_button_disabled_bg",
      _dark: "dark.input_search_button_disabled_bg",
    },
    input_search_button_disabled_border: {
      default: "light.input_search_button_disabled_border",
      _dark: "dark.input_search_button_disabled_border",
    },
    input_search_button_disabled_icon: {
      default: "light.input_search_button_disabled_icon",
      _dark: "dark.input_search_button_disabled_icon",
    },
    //Table
    table_bg: {
      default: "light.table_bg",
      _dark: "dark.table_bg",
    },
    table_header_bg: {
      default: "light.table_header_bg",
      _dark: "dark.table_header_bg",
    },
    table_header_text_color: {
      default: "light.table_header_text_color",
      _dark: "dark.table_header_text_color",
    },
    table_border_color: {
      default: "light.table_border_color",
      _dark: "dark.table_border_color",
    },
    table_body_text_color: {
      default: "light.table_body_text_color",
      _dark: "dark.table_body_text_color",
    },
    table_body_second_row: {
      default: "light.table_body_second_row",
      _dark: "dark.table_body_second_row",
    },
    table_row_hover: {
      default: "light.table_row_hover",
      _dark: "dark.table_row_hover",
    },
    table_selected_bg: {
      default: "light.table_selected_bg",
      _dark: "dark.table_selected_bg",
    },

    table_selected_hover_bg: {
      default: "light.table_selected_hover_bg",
      _dark: "dark.table_selected_hover_bg",
    },
    table_addkala_bg: {
      default: "light.table_addkala_bg",
      _dark: "dark.table_addkala_bg",
    },

    // Pagination
    pagination_bg: {
      default: "light.pagination_bg",
      _dark: "dark.pagination_bg",
    },

    pagination_border_color: {
      default: "light.pagination_border_color",
      _dark: "dark.pagination_border_color",
    },

    pagination_text_color: {
      default: "light.pagination_text_color",
      _dark: "dark.pagination_text_color",
    },

    pagination_hover_bg: {
      default: "light.pagination_hover_bg",
      _dark: "dark.pagination_hover_bg",
    },

    pagination_hover_text_color: {
      default: "light.pagination_hover_text_color",
      _dark: "dark.pagination_hover_text_color",
    },

    pagination_hover_border_color: {
      default: "light.pagination_hover_border_color",
      _dark: "dark.pagination_hover_border_color",
    },

    pagination_active_bg: {
      default: "light.pagination_active_bg",
      _dark: "dark.pagination_active_bg",
    },

    pagination_active_text_color: {
      default: "light.pagination_active_text_color",
      _dark: "dark.pagination_active_text_color",
    },

    pagination_disabled_text_color: {
      default: "light.pagination_disabled_text_color",
      _dark: "dark.pagination_disabled_text_color",
    },
    pagination_select_text_color: {
      default: "light.pagination_select_text_color",
      _dark: "dark.pagination_select_text_color",
    },

    pagination_select_hover_text_color: {
      default: "light.pagination_select_hover_text_color",
      _dark: "dark.pagination_select_hover_text_color",
    },

    pagination_select_selected_text_color: {
      default: "light.pagination_select_selected_text_color",
      _dark: "dark.pagination_select_selected_text_color",
    },
    pagination_select_selected_bg: {
      default: "light.pagination_select_selected_bg",
      _dark: "dark.pagination_select_selected_bg",
    },

    // Table Scrollbar
    table_scrollbar_bg: {
      default: "light.table_scrollbar_bg",
      _dark: "dark.table_scrollbar_bg",
    },

    table_scrollbar_thumb: {
      default: "light.table_scrollbar_thumb",
      _dark: "dark.table_scrollbar_thumb",
    },

    table_scrollbar_thumb_hover: {
      default: "light.table_scrollbar_thumb_hover",
      _dark: "dark.table_scrollbar_thumb_hover",
    },
    // Table Status Rows
    table_row_ebtali: {
      default: "light.table_row_ebtali",
      _dark: "dark.table_row_ebtali",
    },

    table_row_eslahi: {
      default: "light.table_row_eslahi",
      _dark: "dark.table_row_eslahi",
    },

    table_row_return: {
      default: "light.table_row_return",
      _dark: "dark.table_row_return",
    },

    table_row_success: {
      default: "light.table_row_success",
      _dark: "dark.table_row_success",
    },

    table_row_failed: {
      default: "light.table_row_failed",
      _dark: "dark.table_row_failed",
    },

    table_row_inprocess: {
      default: "light.table_row_inprocess",
      _dark: "dark.table_row_inprocess",
    },

    table_row_alter: {
      default: "light.table_row_alter",
      _dark: "dark.table_row_alter",
    },
    table_filter_icon: {
      default: "light.table_filter_icon",
      _dark: "dark.table_filter_icon",
    },
    table_filter_hover: {
      default: "light.table_filter_hover",
      _dark: "dark.table_filter_hover",
    },
    table_filter_active: {
      default: "light.table_filter_active",
      _dark: "dark.table_filter_active",
    },
    table_filter_dropdown_bg: {
      default: "light.table_filter_dropdown_bg",
      _dark: "dark.table_filter_dropdown_bg",
    },
    table_filter_dropdown_border: {
      default: "light.table_filter_dropdown_border",
      _dark: "dark.table_filter_dropdown_border",
    },
    table_filter_dropdown_text: {
      default: "light.table_filter_dropdown_text",
      _dark: "dark.table_filter_dropdown_text",
    },
    table_filter_dropdown_hover: {
      default: "light.table_filter_dropdown_hover",
      _dark: "dark.table_filter_dropdown_hover",
    },
    table_filter_dropdown_selected_bg: {
      default: "light.table_filter_dropdown_selected_bg",
      _dark: "dark.table_filter_dropdown_selected_bg",
    },
    table_filter_dropdown_selected_text: {
      default: "light.table_filter_dropdown_selected_text",
      _dark: "dark.table_filter_dropdown_selected_text",
    },
    table_filter_confirm_text: {
      default: "light.table_filter_confirm_text",
      _dark: "dark.table_filter_confirm_text",
    },
    table_filter_reset_text: {
      default: "light.table_filter_reset_text",
      _dark: "dark.table_filter_reset_text",
    },
    table_filter_reset_hover_text: {
      default: "light.table_filter_reset_hover_text",
      _dark: "dark.table_filter_reset_hover_text",
    },
    table_filter_reset_disabled_text: {
      default: "light.table_filter_reset_disabled_text",
      _dark: "dark.table_filter_reset_disabled_text",
    },
    table_expand_bg: {
      default: "light.table_expand_bg",
      _dark: "dark.table_expand_bg",
    },

    table_expand_border: {
      default: "light.table_expand_border",
      _dark: "dark.table_expand_border",
    },

    table_expand_icon: {
      default: "light.table_expand_icon",
      _dark: "dark.table_expand_icon",
    },

    table_expand_hover_bg: {
      default: "light.table_expand_hover_bg",
      _dark: "dark.table_expand_hover_bg",
    },

    table_expand_hover_border: {
      default: "light.table_expand_hover_border",
      _dark: "dark.table_expand_hover_border",
    },

    table_expand_hover_icon: {
      default: "light.table_expand_hover_icon",
      _dark: "dark.table_expand_hover_icon",
    },

    table_expand_active_bg: {
      default: "light.table_expand_active_bg",
      _dark: "dark.table_expand_active_bg",
    },

    table_expand_active_border: {
      default: "light.table_expand_active_border",
      _dark: "dark.table_expand_active_border",
    },

    table_expand_active_icon: {
      default: "light.table_expand_active_icon",
      _dark: "dark.table_expand_active_icon",
    },
    status_processing: {
      default: "light.status_processing",
      _dark: "dark.status_processing",
    },

    status_success: {
      default: "light.status_success",
      _dark: "dark.status_success",
    },

    status_failed: {
      default: "light.status_failed",
      _dark: "dark.status_failed",
    },

    status_warning: {
      default: "light.status_warning",
      _dark: "dark.status_warning",
    },

    status_not_found: {
      default: "light.status_not_found",
      _dark: "dark.status_not_found",
    },

    status_connection_error: {
      default: "light.status_connection_error",
      _dark: "dark.status_connection_error",
    },

    status_default: {
      default: "light.status_default",
      _dark: "dark.status_default",
    },
    modal_bg: {
      default: "light.modal_bg",
      _dark: "dark.modal_bg",
    },

    modal_border: {
      default: "light.modal_border",
      _dark: "dark.modal_border",
    },

    modal_text: {
      default: "light.modal_text",
      _dark: "dark.modal_text",
    },

    modal_overlay: {
      default: "light.modal_overlay",
      _dark: "dark.modal_overlay",
    },

    // Menu
    menu_bg: {
      default: "light.menu_bg",
      _dark: "dark.menu_bg",
    },

    menu_text: {
      default: "light.menu_text",
      _dark: "dark.menu_text",
    },

    menu_border: {
      default: "light.menu_border",
      _dark: "dark.menu_border",
    },

    menu_hover_bg: {
      default: "light.menu_hover_bg",
      _dark: "dark.menu_hover_bg",
    },

    menu_hover_text: {
      default: "light.menu_hover_text",
      _dark: "dark.menu_hover_text",
    },

    menu_divider: {
      default: "light.menu_divider",
      _dark: "dark.menu_divider",
    },

    menu_group_text: {
      default: "light.menu_group_text",
      _dark: "dark.menu_group_text",
    },

    menu_disabled: {
      default: "light.menu_disabled",
      _dark: "dark.menu_disabled",
    },
    menu_sub_bg: {
      default: "light.menu_sub_bg",
      _dark: "dark.menu_sub_bg",
    },
    menu_sub_shadow: {
      default: "light.menu_sub_shadow",
      _dark: "dark.menu_sub_shadow",
    },
    //Clipboard
    clipboard_msg_bg: {
      default: "light.clipboard_msg_bg",
      _dark: "dark.clipboard_msg_bg",
    },
    clipboard_msg_color: {
      default: "light.clipboard_msg_color",
      _dark: "dark.clipboard_msg_color",
    },
    login_bg: {
      default: "light.login_bg",
      _dark: "dark.login_bg",
    },
    login_label_input: {
      default: "light.login_label_input",
      _dark: "dark.login_label_input",
    },
    login_box_shadow: {
      default: "light.login_box_shadow",
      _dark: "dark.login_box_shadow",
    },
    login_label_input_base: {
      default: "light.login_label_input_base",
      _dark: "dark.login_label_input_base",
    },
    sidebar_seprator_bg: {
      default: "light.sidebar_seprator_bg",
      _dark: "dark.sidebar_seprator_bg",
    },
    text: {
      default: "light.text",
      _dark: "dark.text",
    },

    textSecondary: {
      default: "light.textSecondary",
      _dark: "dark.textSecondary",
    },

    border: {
      default: "light.border",
      _dark: "dark.border",
    },

    input: {
      default: "light.input",
      _dark: "dark.input",
    },

    tableHeader: {
      default: "light.tableHeader",
      _dark: "dark.tableHeader",
    },

    tableRow: {
      default: "light.tableRow",
      _dark: "dark.tableRow",
    },

    tableHover: {
      default: "light.tableRowHover",
      _dark: "dark.tableRowHover",
    },
    //PopConfirm Delete
    popconfirm_bg: {
      default: "light.popconfirm_bg",
      _dark: "dark.popconfirm_bg",
    },

    popconfirm_border: {
      default: "light.popconfirm_border",
      _dark: "dark.popconfirm_border",
    },

    popconfirm_title: {
      default: "light.popconfirm_title",
      _dark: "dark.popconfirm_title",
    },

    popconfirm_text: {
      default: "light.popconfirm_text",
      _dark: "dark.popconfirm_text",
    },

    popconfirm_icon: {
      default: "light.popconfirm_icon",
      _dark: "dark.popconfirm_icon",
    },

    popconfirm_cancel_bg: {
      default: "light.popconfirm_cancel_bg",
      _dark: "dark.popconfirm_cancel_bg",
    },

    popconfirm_cancel_border: {
      default: "light.popconfirm_cancel_border",
      _dark: "dark.popconfirm_cancel_border",
    },

    popconfirm_cancel_text: {
      default: "light.popconfirm_cancel_text",
      _dark: "dark.popconfirm_cancel_text",
    },

    popconfirm_cancel_hover: {
      default: "light.popconfirm_cancel_hover",
      _dark: "dark.popconfirm_cancel_hover",
    },

    popconfirm_confirm_bg: {
      default: "light.popconfirm_confirm_bg",
      _dark: "dark.popconfirm_confirm_bg",
    },

    popconfirm_confirm_hover: {
      default: "light.popconfirm_confirm_hover",
      _dark: "dark.popconfirm_confirm_hover",
    },

    popconfirm_confirm_text: {
      default: "light.popconfirm_confirm_text",
      _dark: "dark.popconfirm_confirm_text",
    },
    //Acordian
    acordian_bg: {
      default: "light.acordian_bg",
      _dark: "dark.acordian_bg",
    },
    acordian_border_color: {
      default: "light.acordian_border_color",
      _dark: "dark.acordian_border_color",
    },
    // Dashboard
    dashboard_card_bg: {
      default: "light.dashboard_card_bg",
      _dark: "dark.dashboard_card_bg",
    },

    dashboard_inside_card_bg: {
      default: "light.dashboard_inside_card_bg",
      _dark: "dark.dashboard_inside_card_bg",
    },

    dashboard_red_icon_bg: {
      default: "light.dashboard_red_icon_bg",
      _dark: "dark.dashboard_red_icon_bg",
    },

    dashboard_red_icon_color: {
      default: "light.dashboard_red_icon_color",
      _dark: "dark.dashboard_red_icon_color",
    },

    dashboard_green_icon_bg: {
      default: "light.dashboard_green_icon_bg",
      _dark: "dark.dashboard_green_icon_bg",
    },

    dashboard_green_icon_color: {
      default: "light.dashboard_green_icon_color",
      _dark: "dark.dashboard_green_icon_color",
    },

    dashboard_card_desc_color: {
      default: "light.dashboard_card_desc_color",
      _dark: "dark.dashboard_card_desc_color",
    },
    dashboard_card_title_color: {
      default: "light.dashboard_card_title_color",
      _dark: "dark.dashboard_card_title_color",
    },
    dashboard_filter_box_bg: {
      default: "light.dashboard_filter_box_bg",
      _dark: "dark.dashboard_filter_box_bg",
    },
    //Plans
    plan_none_bg:{
      default : "light.plan_none_bg",
      _dark : "dark.plan_none_bg"
    },
    plan_none_color:{
      default : "light.plan_none_color",
      _dark : "dark.plan_none_color"
    },
    plan_none_glow:{
      default:"light.plan_none_glow",
      _dark:"dark.plan_none_glow"
    },
    plan_plus_bg: {
      default: "light.plan_plus_bg",
      _dark: "dark.plan_plus_bg",
    },
    plan_plus_color: {
      default: "light.plan_plus_color",
      _dark: "dark.plan_plus_color",
    },
    plan_plus_glow: {
      default: "light.plan_plus_glow",
      _dark: "dark.plan_plus_glow",
    },

    plan_pro_bg: {
      default: "light.plan_pro_bg",
      _dark: "dark.plan_pro_bg",
    },
    plan_pro_color: {
      default: "light.plan_pro_color",
      _dark: "dark.plan_pro_color",
    },
    plan_pro_glow: {
      default: "light.plan_pro_glow",
      _dark: "dark.plan_pro_glow",
    },

    plan_trial_bg: {
      default: "light.plan_trial_bg",
      _dark: "dark.plan_trial_bg",
    },
    plan_trial_color: {
      default: "light.plan_trial_color",
      _dark: "dark.plan_trial_color",
    },
    plan_trial_glow: {
      default: "light.plan_trial_glow",
      _dark: "dark.plan_trial_glow",
    },
    //Plans Pricing
    pricing_page_bg: { default: "light.pricing_page_bg", _dark: "dark.pricing_page_bg" },
  pricing_card_bg: { default: "light.pricing_card_bg", _dark: "dark.pricing_card_bg" },
  pricing_card_border: { default: "light.pricing_card_border", _dark: "dark.pricing_card_border" },
  pricing_card_border_featured: { default: "light.pricing_card_border_featured", _dark: "dark.pricing_card_border_featured" },
 
  pricing_text_primary: { default: "light.pricing_text_primary", _dark: "dark.pricing_text_primary" },
  pricing_text_secondary: { default: "light.pricing_text_secondary", _dark: "dark.pricing_text_secondary" },
  pricing_text_muted: { default: "light.pricing_text_muted", _dark: "dark.pricing_text_muted" },
  pricing_text_faint: { default: "light.pricing_text_faint", _dark: "dark.pricing_text_faint" },
 
  pricing_surface_mint: { default: "light.pricing_surface_mint", _dark: "dark.pricing_surface_mint" },
  pricing_surface_teal_tint: { default: "light.pricing_surface_teal_tint", _dark: "dark.pricing_surface_teal_tint" },
 
  pricing_accent_teal_light: { default: "light.pricing_accent_teal_light", _dark: "dark.pricing_accent_teal_light" },
  pricing_accent_teal: { default: "light.pricing_accent_teal", _dark: "dark.pricing_accent_teal" },
  pricing_accent_teal_hover: { default: "light.pricing_accent_teal_hover", _dark: "dark.pricing_accent_teal_hover" },
  pricing_accent_teal_dark: { default: "light.pricing_accent_teal_dark", _dark: "dark.pricing_accent_teal_dark" },
 
  pricing_enterprise_bg: { default: "light.pricing_enterprise_bg", _dark: "dark.pricing_enterprise_bg" },
  pricing_enterprise_text: { default: "light.pricing_enterprise_text", _dark: "dark.pricing_enterprise_text" },
  pricing_enterprise_text_muted: { default: "light.pricing_enterprise_text_muted", _dark: "dark.pricing_enterprise_text_muted" },
  pricing_enterprise_border: { default: "light.pricing_enterprise_border", _dark: "dark.pricing_enterprise_border" },
  pricing_enterprise_dot: { default: "light.pricing_enterprise_dot", _dark: "dark.pricing_enterprise_dot" },
 
  pricing_shine: { default: "light.pricing_shine", _dark: "dark.pricing_shine" },
  },
};

export default extendTheme(
  {
    config,
    colors,
    semanticTokens,
    breakpoints,
  },
  globalStyles,
  buttonStyles,
  badgeStyles,
  linkStyles,
  drawerStyles,
  CardComponent,
  CardBodyComponent,
  CardHeaderComponent,
  MainPanelComponent,
  PanelContentComponent,
  PanelContainerComponent,
  inputStyles,
);
